import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_URL_DISP;

export const getTokenCliente = async (acontID, token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-token-internal?entry_customer_id=${acontID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Erro ao buscar o token do cliente');
    }
  } catch (error) {
    console.error('Erro na API ao buscar o token do cliente:', error);
    throw error;
  }
};

export const cancelTrigger = async (triggerId, userId, token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/trigger/cancel/${triggerId}/${userId}`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Erro ao cancelar o trigger');
    }
  } catch (error) {
    console.error('Erro na API ao cancelar o trigger:', error);
    throw error;
  }
};

export const fetchTriggersByStatus = async (acontID, token, statusId, page) => {
  const statusParam = statusId ? `status_id=${statusId}&` : '';
  const pageParam = `page=${page}&`;

  try {
    const response = await axios.get(`${API_BASE_URL}/get-triggers/customer/${acontID}?${statusParam}${pageParam}perPage=20`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Erro ao buscar triggers por status');
    }
  } catch (error) {
    console.error('Erro na API ao buscar triggers por status:', error);
    throw error;
  }
};

export const fetchTriggersByDate = async (acontID, token, startDate, endDate, page) => {
  const start = startDate ? `${startDate} 00:00:01` : '';
  const end = endDate ? `${endDate} 23:59:00` : '';
  const pageParam = `page=${page}&`;

  try {
    const response = await axios.get(`${API_BASE_URL}/get-triggers/customer/${acontID}?${pageParam}perPage=20&start_date=${start}&end_date=${end}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Erro ao buscar triggers por data');
    }
  } catch (error) {
    console.error('Erro na API ao buscar triggers por data:', error);
    throw error;
  }
};

export const fetchTriggersByStatusAndDate = async (channelID, token, statusId, startDate, endDate, page) => {
  const statusParam = statusId ? `status_id=${statusId}&` : '';
  const start = startDate ? `${startDate} 00:00:01` : '';
  const end = endDate ? `${endDate} 23:59:00` : '';
  const pageParam = `page=${page}&`;

  try {
    const response = await axios.get(`${API_BASE_URL}/get-triggers/customer/${channelID}?${statusParam}${pageParam}perPage=20&start_date=${start}&end_date=${end}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Erro ao buscar triggers por status e data');
    }
  } catch (error) {
    console.error('Erro na API ao buscar triggers por status e data:', error);
    throw error;
  }
};

export const fetchTriggersAdvanced = async (acontID, token, filters = {}, page = 1, perPage = 20) => {
  const params = new URLSearchParams();

  params.append('page', String(page));
  params.append('perPage', String(perPage));

  const appendArrayParam = (key, values) => {
    if (!Array.isArray(values)) return;
    values
      .filter((value) => value !== undefined && value !== null && String(value) !== '')
      .forEach((value) => params.append(key, String(value)));
  };

  if (filters.start_date) params.append('start_date', filters.start_date);
  if (filters.end_date) params.append('end_date', filters.end_date);
  if (filters.entry_tag) params.append('entry_tag', filters.entry_tag);
  if (filters.trigger_identify) params.append('trigger_identify', filters.trigger_identify);
  if (filters.channel_name) params.append('channel_name', filters.channel_name);

  appendArrayParam('status_id', filters.status_id);
  appendArrayParam('user_id', filters.user_id);
  appendArrayParam('quick_message_id', filters.quick_message_id);

  try {
    const response = await axios.get(`${API_BASE_URL}/get-triggers/customer/${acontID}?${params.toString()}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Erro ao buscar triggers com filtros avançados');
  } catch (error) {
    console.error('Erro na API ao buscar triggers com filtros avançados:', error);
    throw error;
  }
};

export const fetchBots = async (acontID, phoneNumber, token, page = 1, perPage = 20) => {
  try {
    let cachedToken = JSON.parse(localStorage.getItem('dataToken') || '{}');

    if (!cachedToken?.token) {
      cachedToken = await getTokenCliente(acontID, token);
      if (!cachedToken?.token) {
        throw new Error('Bearer token não encontrado');
      }
      localStorage.setItem('dataToken', JSON.stringify(cachedToken));
    }

    const response = await axios.get(`${API_BASE_URL}/get-bots/customer/${acontID}/${phoneNumber}?perPage=${perPage}&page=${page}`, {
      headers: {
        'accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Erro ao buscar bots');
    }
  } catch (error) {
    console.error('Erro na API ao buscar bots:', error);
    throw error;
  }
};

export const fetchTags = async (acontID, token, page = 1, perPage = 150) => {
  const endpoints = [
    `${API_BASE_URL}/get-tags/customer/${acontID}?perPage=${perPage}&page=${page}`,
    `${API_BASE_URL}/tags/customer/${acontID}?perPage=${perPage}&page=${page}`,
    `${API_BASE_URL}/get-tags/${acontID}?perPage=${perPage}&page=${page}`,
    `${API_BASE_URL}/tags/${acontID}?perPage=${perPage}&page=${page}`,
  ];

  let lastError = null;

  for (const endpoint of endpoints) {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        const responseData = response.data;

        if (Array.isArray(responseData)) {
          return responseData;
        }

        return responseData?.data || [];
      }
    } catch (error) {
      lastError = error;
    }
  }

  if (lastError) {
    console.error('Erro ao buscar tags:', lastError);
  }

  return [];
};

export const fetchUsersPaginated = async (customerId, token, page = 1, perPage = 20, entryUserName = '') => {
  const normalizedName = typeof entryUserName === 'string' ? entryUserName.trim() : '';
  const nameQuery = normalizedName ? `&entry_user_name=${encodeURIComponent(normalizedName)}` : '';

  try {
    const response = await axios.get(
      `${API_BASE_URL}/get-users/customers/${customerId}?perPage=${perPage}&page=${page}${nameQuery}`,
      {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      const responseData = response.data;
      const lastPage = responseData?.last_page || responseData?.lastPage || 1;

      return {
        data: (responseData?.data || []).map((user) => ({
          id: user.id,
          name: user.name || `#${user.id}`,
        })),
        total: responseData?.total || 0,
        current_page: responseData?.current_page || page,
        perPage: responseData?.perPage || perPage,
        last_page: lastPage,
      };
    }

    throw new Error('Erro ao buscar usuários');
  } catch (error) {
    console.error('Erro na API ao buscar usuários:', error);
    throw error;
  }
};

export const fetchQuickMessagesPaginated = async (customerId, token, page = 1, perPage = 20, quickMessageName = '') => {
  const normalizedName = typeof quickMessageName === 'string' ? quickMessageName.trim() : '';
  const nameQuery = normalizedName ? `&quick_message_name=${encodeURIComponent(normalizedName)}` : '';

  try {
    const response = await axios.get(
      `${API_BASE_URL}/get-quick-messages/customer/${customerId}?perPage=${perPage}&page=${page}${nameQuery}`,
      {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      const responseData = response.data;
      const lastPage = responseData?.last_page || responseData?.lastPage || 1;

      return {
        data: (responseData?.data || [])
          .filter((template) => template?.id)
          .map((template) => ({
            id: template.id,
            tag: template.tag || template.quick_message_name || `#${template.id}`,
            channel_id: template.channel_id,
          })),
        total: responseData?.total || 0,
        current_page: responseData?.current_page || page,
        perPage: responseData?.perPage || perPage,
        last_page: lastPage,
      };
    }

    throw new Error('Erro ao buscar templates');
  } catch (error) {
    console.error('Erro na API ao buscar templates:', error);
    throw error;
  }
};

export const fetchTagsPaginated = async (acontID, token, page = 1, perPage = 150, name = '') => {
  const normalizedName = typeof name === 'string' ? name.trim() : '';
  const nameQuery = normalizedName ? `&name=${encodeURIComponent(normalizedName)}` : '';
  const endpoints = [
    `${API_BASE_URL}/get-tags/customer/${acontID}?perPage=${perPage}&page=${page}${nameQuery}`,
    `${API_BASE_URL}/tags/customer/${acontID}?perPage=${perPage}&page=${page}${nameQuery}`,
    `${API_BASE_URL}/get-tags/${acontID}?perPage=${perPage}&page=${page}${nameQuery}`,
    `${API_BASE_URL}/tags/${acontID}?perPage=${perPage}&page=${page}${nameQuery}`,
  ];

  let lastError = null;

  for (const endpoint of endpoints) {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        const responseData = response.data;
        const lastPage = responseData?.last_page || responseData?.lastPage || 1;

        if (Array.isArray(responseData)) {
          return {
            data: responseData,
            total: responseData.length,
            current_page: page,
            perPage,
            last_page: page,
            total_pages: page,
          };
        }

        return {
          data: responseData?.data || [],
          total: responseData?.total || 0,
          current_page: responseData?.current_page || page,
          perPage: responseData?.perPage || perPage,
          last_page: lastPage,
          total_pages: lastPage,
        };
      }
    } catch (error) {
      lastError = error;
    }
  }

  if (lastError) {
    console.error('Erro ao buscar tags paginadas:', lastError);
  }

  return {
    data: [],
    total: 0,
    current_page: page,
    perPage,
    last_page: 1,
    total_pages: 1,
  };
};

export const interruptTrigger = async (acontID, token) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/trigger/interrupt/${acontID}?status_id=6`, {
      headers: {
        'accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Erro ao interromper o trigger');
    }
  } catch (error) {
    console.error('Erro na API ao interromper o trigger:', error);
    throw error;
  }
};

export const duplicateTrigger = async (customerId, triggerId, scheduleDateTime, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/trigger/duplicate/${customerId}`, 
      new URLSearchParams({
        trigger_id: triggerId,
        schedule_datetime: scheduleDateTime
      }), 
      {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Erro ao duplicar o trigger');
    }
  } catch (error) {
    console.error('Erro na API ao duplicar o trigger:', error);
    throw error;
  }
};

export const fetchChannels = async (customerId, token, page = 1, perPage = 50, channelName = '') => {
  try {
    let cachedToken = JSON.parse(localStorage.getItem('dataToken') || '{}');

    if (!cachedToken?.token) {
      cachedToken = await getTokenCliente(customerId, token);
      if (!cachedToken?.token) {
        throw new Error('Token inválido ou não encontrado');
      }
      localStorage.setItem('dataToken', JSON.stringify(cachedToken));
    }

    const nameParam = channelName ? `&channel_name=${encodeURIComponent(channelName)}` : '';
    const response = await axios.get(
      `${process.env.REACT_APP_URL_DISP}/get-channels/customer/${customerId}?perPage=${perPage}&page=${page}${nameParam}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'accept': 'application/json',
        },
      }
    );

    if (response.status === 200) {
      // Filtrar canais para WhatsApp, Instagram, WABA
      const filteredChannels = response.data.data.filter(
        (channel) =>
          channel.channel_id === 1 ||
          channel.channel_id === 5 ||
          channel.channel_id === 6
      );

      return {
        channels: filteredChannels,
        current_page: response.data.current_page || page,
        last_page: response.data.last_page || 1,
        total: response.data.total || 0,
      };
    } else {
      throw new Error(`Erro ao buscar os canais na página ${page}`);
    }
  } catch (error) {
    console.error('Erro na API ao buscar os canais:', error.message);
    throw new Error('Erro ao buscar os canais. Tente novamente mais tarde.');
  }
};

export const fetchChannelsPaginated = async (customerId, token) => {
  try {
    let cachedToken = JSON.parse(localStorage.getItem('dataToken') || '{}');

    if (!cachedToken?.token) {
      cachedToken = await getTokenCliente(customerId, token);
      if (!cachedToken?.token) {
        throw new Error('Token inválido ou não encontrado');
      }
      localStorage.setItem('dataToken', JSON.stringify(cachedToken));
    }

    let allChannels = [];
    let currentPage = 1;
    let lastPage = 1;

    while (currentPage <= lastPage) {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_DISP}/get-channels/customer/${customerId}?perPage=150&page=${currentPage}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'accept': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        // Filtrar canais para WhatsApp, Instagram, WABA
        const filteredChannels = response.data.data.filter(
          (channel) =>
            channel.channel_id === 1 ||
            channel.channel_id === 5 ||
            channel.channel_id === 6
        );
        allChannels = [...allChannels, ...filteredChannels];
        lastPage = response.data.last_page || 1;
        currentPage += 1;
      } else {
        throw new Error(`Erro ao buscar os canais na página ${currentPage}`);
      }
    }

    return {
      channels: allChannels,
    };
  } catch (error) {
    console.error('Erro na API ao buscar os canais:', error.message);
    throw new Error('Erro ao buscar os canais. Tente novamente mais tarde.');
  }
};